export const achievementData = {
  bio: "Beyond technology, I am highly interested in tech events and hackathons that improve skills as well as give freedom to think out of boundaries. I have attended multiple tech events of the cryptocurrency and hackathon. ",
  achievements: [
    {
      id: 1,
      title: "Smart India hackathon",
      details: "Developed a face recognization app in the event coding.",
      date: "feb 20, 2018",
      field: "hackathon",
      image:
        "https://user-images.githubusercontent.com/26837182/134398077-f3769980-5659-407b-ae7c-f9892c61d95f.jpg",
    },
    {
      id: 2,
      title: "Bitmax Event",
      details: "Bitmax arrange a cryptocurrency event for tech peoples",
      date: "Aug 20, 2019",
      field: "Cryptocurrency",
      image:
        "https://user-images.githubusercontent.com/26837182/134398500-17242210-8f8f-4fce-a448-d38cdd89806b.png",
    },
    {
      id: 3,
      title: "Kiet Tech Event",
      details:
        "Project to decompile and reverse-engineer Whatsapp and Make a modefied whatsapp version .",
      date: "Aug 20, 2018",
      field: "Hacking",
      image:
        "https://user-images.githubusercontent.com/26837182/134397899-faebbff1-6a56-4f9a-a4df-a48caa92b0ba.jpg",
    },
  ],
};

// Do not remove any fields.
// Leave it blank instead as shown below.

/*

export const achievementData = {
    bio : "",
    achievements : []
}

*/
